var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.222229,
    width: 120,
    height: 120,
    rx: 4,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.8148 37.4074H37.1851C36.085 37.4074 35.0299 37.8444 34.252 38.6224C33.474 39.4003 33.037 40.4554 33.037 41.5556V78.8889C33.037 79.989 33.474 81.0441 34.252 81.8221C35.0299 82.6 36.085 83.037 37.1851 83.037H82.8148C83.9149 83.037 84.97 82.6 85.7479 81.8221C86.5259 81.0441 86.9629 79.989 86.9629 78.8889V41.5556C86.9629 40.4554 86.5259 39.4003 85.7479 38.6224C84.97 37.8444 83.9149 37.4074 82.8148 37.4074ZM82.8148 41.5556V68.1944L76.0559 61.4382C75.6707 61.0529 75.2133 60.7472 74.71 60.5387C74.2067 60.3302 73.6672 60.2228 73.1224 60.2228C72.5775 60.2228 72.0381 60.3302 71.5347 60.5387C71.0314 60.7472 70.574 61.0529 70.1888 61.4382L65.0037 66.6233L53.5962 55.2159C52.8184 54.4386 51.7637 54.0019 50.664 54.0019C49.5643 54.0019 48.5097 54.4386 47.7318 55.2159L37.1851 65.7626V41.5556H82.8148ZM37.1851 71.6296L50.6666 58.1481L71.4074 78.8889H37.1851V71.6296ZM82.8148 78.8889H77.2744L67.9411 69.5556L73.1262 64.3704L82.8148 74.0615V78.8889ZM64.1481 52.963C64.1481 52.3476 64.3306 51.7461 64.6724 51.2345C65.0143 50.7229 65.5002 50.3241 66.0686 50.0887C66.6371 49.8532 67.2627 49.7916 67.8662 49.9116C68.4697 50.0317 69.024 50.328 69.4591 50.7631C69.8942 51.1982 70.1905 51.7525 70.3105 52.356C70.4306 52.9595 70.369 53.5851 70.1335 54.1535C69.898 54.722 69.4993 55.2079 68.9876 55.5498C68.476 55.8916 67.8745 56.0741 67.2592 56.0741C66.4341 56.0741 65.6428 55.7463 65.0593 55.1629C64.4759 54.5794 64.1481 53.7881 64.1481 52.963Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.584dce84ec2abf4c97fa919eb65bf0e1.svg";
export { ForwardRef as ReactComponent };